<script>
import framework from '@/CommonDP/components/FrameWork/index.backup.vue'
import supplierService from "@/xgzdService/supperson-service"
export default {
  extends: framework,
  methods: {
    // 获取左侧单位
    async getTree() {
      const { data } = await supplierService.getOrgTree({
        enterpriseId: this.enterpriseId
      });
      if (data) {
        this.tree = data;
        this.searchQuery.deptId = data[0].deptId;
        this.defaultExpandedKeys.push(data[0].deptId);
        this.getOrgUserList(1);
      }
    },

  }
}
</script>